<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
    <path d="M6 4.5L10 8L6 11.5" stroke="currentColor" />
  </svg>
</template>
